module.exports = __webpack_public_path__ + "img/marketing-target-dark.2c3c2af7.svg";